import { createSlice } from '@reduxjs/toolkit';

const memberReportingSlice = createSlice({
  name: 'memberReporting',
  initialState: {
    rows: [],
  },
  reducers: {
    replaceData(state, action) {
      state.rows = action.payload;
    },
  },
});

export const memberReportingActions = memberReportingSlice.actions;
export default memberReportingSlice;